import React from "react";
import { DataTableComponent } from "../DataTable";
import { PrimaryButton } from "../Cta";
import Icon from "../icons";

export default function TransactionHistoryModal({ close, column, data }) {
  return (
    <div className=" position-fixed top-0 start-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-center">
      <div className="row w-100">
        <div className="offset-lg-2 col-lg-8">
          <div className="bg-white e-border-radius-24 e-p-32px">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className=" text-start e-font-weight-600 e-font-14 line-height-32px e-primary-font-poppins">
                Transaction History
              </h5>
              <PrimaryButton
                icon="close-button"
                name=""
                ClassName="bg-white"
                size="16px"
                onPress={close}
              />
            </div>

            <div className="row">
              <div className="col-12">
                <DataTableComponent
                  columns={column}
                  data={data}
                  sortIcon={<Icon icon="sort_col" size="20px" />}
                  className="e-transaction-history-table"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
